<style lang="scss" scoped>
.sidebar {
	background: $grey--500;
	width: 80px;
	position: fixed;
	height: 100%;
	text-align: center;
	&__beta {
		background: $--primary;
		color: white;
		font-size: 10px;
		text-transform: uppercase;
		padding: 5px;
		display: inline-block;
		border-radius: 4px;
		margin-bottom: 15px;
	}
	&__logo {
		width: 34px;
		height: auto;
		margin: auto;
		display: block;
		margin-bottom: 10px;
		margin-top: 40px;
		cursor: pointer;
	}
	&__profile {
		position: absolute;
		bottom: 0;
		button {
			display: block;
			margin: auto;
			margin-bottom: 30px;
			width: 50%;
			height: 50%;
			border-radius: 50%;
			background-color: #2b7be5;
			color: #fff;
			border: 1px solid #2b7be5;
			margin-left: 15px;
			div {
				margin-left: -10px;
			}
		}
	}
	&__navigation {
		text-align: center;
		-webkit-box-flex: 1;
		flex-grow: 1;
		flex-shrink: 1;
		flex-basis: 0px;
		a,
		span {
			cursor: pointer;
			text-decoration: none;
			display: block;
			padding: 20px;
			color: darken($--sidebar-link, 30);
			outline: 0;
			&:focus {
				outline: 0;
			}
			&:hover {
				color: $--sidebar-link;
			}
		}
		i {
			font-size: 20px;
		}
	}
	&__account {
		list-style: none;
		margin: 0;
		padding: 0;
		li {
			border-bottom: 1px solid #eee;
			a {
				display: block;
				padding: 15px 5px;
				color: $grey--200;
				font-weight: 500;
				cursor: pointer;
			}
			&:last-child {
				border-bottom: 0;
			}
		}
	}
}
</style>

<template lang="pug">
.sidebar
	img(src="@/assets/wonde-icon-colour.svg", @click="clickLogo()").sidebar__logo
	.sidebar__beta beta
	.sidebar__navigation
		el-tooltip.item(effect="dark", content="Schools", placement="right")
			router-link(to="/")
				i.fe.fe-home
		//- el-tooltip.item(effect="dark", content="Overview", placement="right")
		//- 	router-link(:to="{ name: 'overview' }")
		//- 		i.fe.fe-eye
		el-tooltip.item(effect="dark", content="Referrals", placement="right", :class="{hasReferrals: referralsCount > 0}")
			router-link(:to="{ name: 'referrals'}", style="position: relative")
				i.fe.fe-list
				div.referral_badge(v-if="referralsCount > 0") {{ referralsCount }}
		el-tooltip.item(effect="dark", content="Activity", placement="right")
			router-link(:to="{ name: 'activity' }")
				i.fe.fe-activity
		el-tooltip.item(effect="dark", content="Settings", placement="right")
			router-link(:to="{ name: 'settings.account' }")
				i.fe.fe-settings
		el-tooltip.item(v-can:view-writebacks, effect="dark", content="Writebacks", placement="right")
			router-link(to="/writebacks")
				i.fe.fe-save
		el-tooltip.item(effect="dark", content="Documentation", placement="right")
			a(href="https://docs.wonde.com/docs/api/sync", target="_blank")
				i.fe.fe-info
		el-tooltip.item(v-can:view-support effect="dark", content="Support", placement="right")
			span
				i.fe.fe-life-buoy(@click.prevent="showSupportModal")
		el-tooltip.item(effect="dark", content="Search", placement="right")
			a(@click="$bus.$emit('toggle-search', true)")
				i.fe.fe-search
	.sidebar__profile(v-if="!$apollo.loading && user")
		el-popover(placement="right", width="300", trigger="click")
			ul.sidebar__account
				li
					router-link(:to="{ name:'settings.account' }") Your account
				li
					a(@click="logout()") Logout
			el-button(slot="reference")
				div {{ user.first_name.charAt(0) }}{{ user.last_name.charAt(0) }}
</template>

<script>
import { onLogout, authKey } from "@/vue-apollo.js";
import gql from "graphql-tag";
export default {
	name: "Sidebar",
	data: () => ({
		user: null
	}),
	methods: {
		query(newQuery) {
			return {
				...this.$route.query,
				...newQuery
			};
		},
		async logout() {
			await this.$apollo.mutate({
				client: "public",
				mutation: gql`
					mutation Logout($token: String!) {
						Logout(token: $token)
					}
				`,
				variables: {
					token: window.localStorage.getItem(authKey),
				}
			});
			await onLogout();
			this.$router.push("/auth/login");
		},
		clickLogo() {
			this.$router.push("/");
		},
		showSupportModal() {
			this.$vuedals.open({
				component: () => import("@/components/modals/VisitSupportModal.vue"),
				title: "Launch support portal"
			});
		}
	},
	apollo: {
		user: {
			query: gql`
				{
					User {
						id
						email
						first_name
						last_name
					}
				}
			`,
			update: r => r.User
		},
		Referrals: {
			query: gql`
				query Referrals {
					Referrals {
						id
						status
					}
				}
			`,
			update: r => r.Referrals
		}
	},
	computed: {
		referralsCount() {
			if (!this.Referrals) return 0;

			return this.Referrals.length;
		}
	},
	watch: {
		$route(to, from) {
			this.$apollo.queries.Referrals.refetch();
		}
	}
};
</script>
<style lang="css" scoped>
.referral_badge {
	border-radius: 100%;
	background-color: #d03428;
	color: #fff;
	padding: 3px 7px;
	font-size: 0.7em;
	display: inline-block;
	position: absolute;
	right: 17px;
	top: 15px;
}

.hasReferrals {
	padding: 20px 5px !important;
}
</style>
